module.exports = __webpack_public_path__ + "img/icon-nodevice.cc369346.svg";